// Mirrors the Android app's TmdbImage helpers (app/.../data/remote/TmdbImage.kt).
const BASE = "https://image.tmdb.org/t/p/";

// Manual-library titles carry artwork that is already a URL — an operator's
// image, or the poster the server generates (/api/library/poster?id=…).
// Prefixing the TMDB base onto those would build a broken URL, so both shapes
// pass through untouched. A TMDB path is exactly one segment ("/abc.jpg"), so
// anything with a directory — our own shipped art under /library-art/ — is
// served by us and passes through too.
const isDirectUrl = (path) => /^https?:\/\//i.test(path) || path.startsWith("/api/") || !/^\/[^/]+$/.test(path);

export function posterUrl(path, { large = false } = {}) {
  if (!path) return null;
  if (isDirectUrl(path)) return path;
  return `${BASE}${large ? "w500" : "w342"}${path}`;
}

export function backdropUrl(path, { hero = false } = {}) {
  if (!path) return null;
  if (isDirectUrl(path)) return path;
  return `${BASE}${hero ? "w1280" : "w780"}${path}`;
}

export function stillUrl(path) {
  return path ? `${BASE}w300${path}` : null;
}